module.exports = "//cdn-static.kwai.net/kos/s101/nlav11312/incentive-encourage/static/img/share/boost/images/ending.8e1a2607.png";